import { action, payload } from 'ts-action'
import { IStrike } from 'models/Strike'
import { IError, IPayload } from 'models/Global'

export const StrikesFetching = action('StrikesFetching', payload<boolean>())

export const GetStrikes = action('GetStrikes', payload<IPayload<IStrike[]>>())

export const GetStrikesErrors = action('GetStrikesErrors', payload<IError>())

export const GetActiveStrikesCount = action(
  'GetActiveStrikesCount',
  payload<number>(),
)

export const ResetStrikes = action('ResetStrikes')
